export default __webpack_public_path__ + "static/media/businnes-eco-logo.bd41394f.svg";